import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from './api-base';

@Injectable({ providedIn: 'root' })
export class ControlflowService {
  private readonly baseUrl = `${API_BASE_URL}/controlflow`;

  constructor(private http: HttpClient) {}

  createTask(payload: any): Observable<{ id: number }> {
    return this.http.post<{ id: number }>(`${this.baseUrl}/tasks`, payload);
  }

  updateTask(taskId: number, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/tasks/${taskId}`, payload);
  }

  createTicket(payload: any): Observable<{ id: number }> {
    return this.http.post<{ id: number }>(`${this.baseUrl}/tickets`, payload);
  }

  updateTicket(ticketId: number, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/tickets/${ticketId}`, payload);
  }

  createEmail(payload: any): Observable<{ id: number }> {
    return this.http.post<{ id: number }>(`${this.baseUrl}/emails`, payload);
  }

  updateEmail(emailId: number, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/emails/${emailId}`, payload);
  }

  listWorkflows(tenantId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/workflows`, {
      params: { tenant_id: tenantId }
    });
  }

  getWorkflow(tenantId: number, workflowId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/workflows/${workflowId}`, {
      params: { tenant_id: tenantId }
    });
  }

  createWorkflow(payload: any): Observable<{ id: number }> {
    return this.http.post<{ id: number }>(`${this.baseUrl}/workflows`, payload);
  }

  updateWorkflow(workflowId: number, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/workflows/${workflowId}`, payload);
  }
}
